export { Corporativo } from "./Corporativo";
